<div class="topbar">
  <button class="hamburger" type="button" aria-label="Toggle menu" (click)="onMenuClick()">
    <i class="bi bi-list"></i>
  </button>

  <div class="topbar-title">
    Welcome to CIXOR PayDay Management portal
  </div>

  <div class="topbar-right">
    <div class="d-flex flex-row mt-2 mt-md-0 mt-lg-0">
      <div class="d-flex flex-column align-items-end justify-content-center">
        <p class="user-name m-0 p-0">Welcome back {{ currentUser?.firstName }}</p>
        <p class="user-level">{{ formattedRole }}</p>
      </div>
    </div>
  </div>
</div>